import { css } from 'styled-components';

const printerScriptStyles = (instanceId, styleProps) => css`
  .cm-s-canvas${instanceId} {
    border-radius: 0.2em;
    height: ${styleProps.height};
    min-height: ${styleProps.minHeight === undefined
      ? styleProps.height
      : styleProps.minHeight};
    line-height: 1.5;
    background: ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors.elevatedBackgroundSecondary
        : props.theme.colors.elevatedBackgroundPrimary};

    .CodeMirror-gutters {
      background: ${(props) => props.theme.colors.elevatedBackgroundPrimary};
      border-right-color: ${(props) => props.theme.colors.grey3};
    }

    .CodeMirror-lines {
      padding: 0.75rem 0;
    }

    .CodeMirror-line {
      padding: 0 0.75rem;
    }

    .CodeMirror-linenumber {
      padding: 0 0.75rem;
      width: 1.875rem;
    }

    .CodeMirror-scroll {
      min-height: ${styleProps.minHeight === undefined
        ? styleProps.height
        : styleProps.minHeight};
    }

    .CodeMirror-cursor {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    .cm-error {
      color: ${(props) => props.theme.colors.redDark};
      font-weight: ${(props) => props.theme.fonts.weightBold};
      text-decoration: underline;
    }

    .cm-comment {
      font-style: italic;
      color: ${(props) => props.theme.colors.grey5};
    }

    .cm-directive {
      color: ${(props) => props.theme.colors.grey5};
      font-weight: ${(props) => props.theme.fonts.weightBold};
    }

    .cm-keyword {
      font-weight: ${(props) => props.theme.fonts.weightBold};
      color: ${(props) => props.theme.colors.yellowDark};
    }

    .cm-output {
      color: ${(props) => props.theme.colors.greenDark};
    }

    .cm-identifier {
      color: ${(props) => props.theme.colors.purpleDark};
    }

    .cm-literal {
      color: ${(props) => props.theme.colors.blueDark};
    }

    .cm-template {
      color: ${(props) => props.theme.colors.textPrimary};
    }

    .cm-op {
      color: ${(props) => props.theme.colors.textPrimary};
    }
  }
`;

export default printerScriptStyles;
